export default __webpack_public_path__ + "static/media/fifa-prediction.9ff6574d.webp";